import { render, staticRenderFns } from "./OaAvatar.vue?vue&type=template&id=4cb8fbc6"
import script from "./OaAvatar.vue?vue&type=script&lang=js"
export * from "./OaAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports